import {DetailTable} from '../../../mapping-classes/detail-table';

export class Requestedphysical implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(requestedPhisicalCards: any) {
    if (!requestedPhisicalCards || requestedPhisicalCards.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = requestedPhisicalCards.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(requestedPhisicalCards);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen deelnemende rekeningen.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'cardNumber',
      'sequenceNumber',
      'status',
      'type',
      'creationDate',
      'registrationDataPreparatorDateTime',
      'notificationDataPreparatorDateTime',
      'registrationPassFactoryDateTime',
      'notificationPassFactoryDateTime',
      'shippingAddress',
      'shipmentType',
      'replacementCardSequenceNumber',
      'requestReason',
    ];
  }

  setRowData(requestedPhisicalCards) {
    requestedPhisicalCards.forEach((requestedPhisicalCard) => {
      if (this.restrictedData) {
        requestedPhisicalCard.compensationLimit = this.shieldedText;
        requestedPhisicalCard.actualBalance = this.shieldedText;
      }
      this.rowData.push(requestedPhisicalCard);
    });
  }
}
